import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { queueSignupConversion } from '../hooks/usePixelPageView';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, setIsAuthenticated, saveToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        console.log('AuthCallback: Processing session_id', sessionId ? 'present' : 'missing');

        if (!sessionId) {
          console.error('AuthCallback: No session_id found in URL hash');
          navigate('/', { replace: true });
          return;
        }

        const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const userData = response.data.user;
        const sessionToken = response.data.session_token;

        console.log('AuthCallback: Login successful for', userData?.email);

        // Save token first
        saveToken(sessionToken);
        
        // Update auth state
        setUser(userData);
        setIsAuthenticated(true);

        // Queue X Ads signup conversion (fires after redirect, once per new account)
        if (response.data.is_new_user) {
          queueSignupConversion(userData?.user_id);
        }

        // Clean URL and navigate - use window.location for a clean break
        // This ensures ProtectedRoute sees the token in localStorage on fresh load
        window.location.replace('/forum');
      } catch (error) {
        console.error('Auth callback error:', error?.response?.data || error.message);
        // On failure, go home instead of looping back to protected route
        window.location.replace('/');
      }
    };

    processSession();
  }, [navigate, setUser, setIsAuthenticated, saveToken]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#C5A059] mb-4"></div>
        <p className="text-white text-lg font-manrope" data-testid="auth-callback-loading">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
